<template>
    <div class="d-flex row">
        <div class="column-container col-lg-6 col-12">
            <div class="p-3">
                <p v-if="infoTitle" v-text="infoTitle" class="info-title d-block"></p>

                <p v-if="infoSynopsis" v-text="infoSynopsis" class="info-text"></p>
            </div>
        </div>

        <div class="column-container col-lg-6 col-12">
            <div class="offer-features-block p-3">
                <p class="info-title" v-text="$t('results.offerBlock.featuresTitle')"></p>
                <ul class="info-text ml-3">
                    <li v-for="(feature, index) in offer?.lender?.features" :key="index">
                        {{ feature }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get'

export default {
    inject: ['offer'],
    computed: {
        infoTitle: function () {
            return get(this.offer, 'other_information.title')
        },
        infoSynopsis: function () {
            return get(this.offer, 'other_information.synopsis')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.column-container {
    .offer-features-block {
        background-color: var(--standard-tag-background-color);
        border-radius: 10px;

        ul {
            list-style-type: disc;
        }
    }
    .info-title {
        font-size: rem(16px);
        font-weight: 700;
        margin-bottom: 10px;
    }

    .info-text {
        font-size: rem(14px);
    }
}
</style>
